/** Stable keys — must match backend `EMAIL_NOTIFICATION_ROW_KEYS`. */
export const QUICKSTAT_EMAIL_NOTIFICATION_ROWS: ReadonlyArray<{
  key: string;
  /** First-column label on QuickOnline (for UI). */
  label: string;
  /** QuickOnline only has Myself for this row. */
  myselfOnly?: boolean;
}> = [
  { key: 'order_placed', label: 'Order is placed' },
  { key: 'cs_confirm', label: 'C/S Confirm', myselfOnly: true },
  { key: 'picked_up_flight_info', label: 'Picked up/Flight Info' },
  { key: 'flight_changes_any', label: 'Flight Changes Any' },
  { key: 'flight_tender_time', label: 'Flight Tender Time' },
  { key: 'recovered', label: 'Recovered' },
  { key: 'cleared_customs', label: 'Cleared Customs' },
  { key: 'out_for_delivery', label: 'Out For Delivery' },
  { key: 'revised_eta', label: 'Revised ETA' },
  { key: 'proof_of_delivery', label: 'Proof of Delivery' },
  { key: 'canceled_shipments', label: 'Canceled Shipments' },
] as const;

export type EmailNotificationPrefsRow = {
  myself: boolean;
  shipper: boolean;
  consignee: boolean;
};

export type EmailNotificationPreferences = Record<
  string,
  EmailNotificationPrefsRow
>;

export function emptyEmailNotificationPreferences(): EmailNotificationPreferences {
  const o: EmailNotificationPreferences = {};
  for (const r of QUICKSTAT_EMAIL_NOTIFICATION_ROWS) {
    o[r.key] = { myself: false, shipper: false, consignee: false };
  }
  return o;
}

/** Payload for API: null if nothing selected. */
export function emailNotificationPreferencesForApi(
  prefs: EmailNotificationPreferences | null | undefined
): Record<string, EmailNotificationPrefsRow> | null {
  if (!prefs) return null;
  let any = false;
  const out: Record<string, EmailNotificationPrefsRow> = {};
  for (const r of QUICKSTAT_EMAIL_NOTIFICATION_ROWS) {
    const row = prefs[r.key] ?? {
      myself: false,
      shipper: false,
      consignee: false,
    };
    const myself = Boolean(row.myself);
    let shipper = Boolean(row.shipper);
    let consignee = Boolean(row.consignee);
    if (r.myselfOnly) {
      shipper = false;
      consignee = false;
    }
    out[r.key] = { myself, shipper, consignee };
    if (myself || shipper || consignee) any = true;
  }
  return any ? out : null;
}
